import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from 'utils';

interface Profile {
  id: string;
  email: string | null;
  username: string | null;
  image: string | null;
  city: string | null;
  birth_date: string | null;
  energy_count: number;
  new_tribute_count: number;
}

interface ProfileState {
  profile: Profile | null;
  loading: boolean;
  error: string | null;
}

const initialState: ProfileState = {
  profile: null,
  loading: false,
  error: null,
};

export const fetchProfile = createAsyncThunk(
  'profile/fetchProfile',
  async (state, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/accounts/profile/');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Не удалось загрузить профиль');
    }
  }
);

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfile(state, action) {
      state.profile = action.payload;
    },
    clearProfile(state) {
      state.profile = null;
      state.error = null;
    },
    setNewTributeCount(state, action) {
      if (state.profile) {
        state.profile.new_tribute_count =
          action.payload === 0 ? 0 : state.profile.new_tribute_count + 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setProfile, clearProfile, setNewTributeCount } = profileSlice.actions;
export default profileSlice.reducer;
